<template>
  <div v-if="viewState=='card'">

    <home-rewards-component/>

    <!--v-for here is just to prevent errors-->
    <component
      v-for="(item, index) in qnResponseOverall"
      :is="checkSurveyStatus(item, index)"
      :key="index"
      :qnResponseSingle="item"
      :answeredCount="answeredCount"
      :formId="item.formid"
      :minUnansweredIndex="minUnansweredIndex"
      :qnResponseOverall="qnResponseOverall"/>
  </div>
</template>

<script>
import HomeRewardsComponent from '../HomeRewardsComponent.vue'; // TODO: Need to move this into the survey folder

import AnsweredSurvey from '../survey/onetime/AnsweredSurvey';
import UnansweredSurvey from '../survey/onetime/UnansweredSurvey';
import LockedSurvey from '../survey/onetime/LockedSurvey';

import HealthcareSurveyResults from '../../resultsObject/SurveyHealthcareResults.js';
import ProphyHistoryResults from '../../resultsObject/SurveyProphyHistoryResults.js';
import FTSAcuteMedResultsHigh from '../../resultsObject/FTSAcuteMedResultsHigh.js';
import FTSAcuteMedResultsLow from '../../resultsObject/FTSAcuteMedResultsLow.js';
import FTSAcuteMedResultsControl from '../../resultsObject/FTSAcuteMedResultsControl.js';

import AimovigSurveyResults from '../../resultsObject/AimovigSurveyResults.js';

import StrongPainkillersSurveyResults from '../../resultsObject/StrongPainkillersSurveyResults.js';

export default {
  name: 'IndividualTab',
  components: {
    HomeRewardsComponent,
    AnsweredSurvey,
    UnansweredSurvey,
    LockedSurvey
  },
  data () {
    return {
      viewState: null, // 2 states, null or card (boolean-like). Set as card card only after fetching userID
      acceptableQnResponseOverall: [],
      acceptableQnFormIdsOverall: []
    };
  },
  computed: {
    answeredCount: function () {
      return this.qnResponseOverall.filter((element) => element.answered === true).length;
    },
    minUnansweredIndex: function () {
      return this.qnResponseOverall.findIndex((element) => element.answered === false);
    }
  },
  mounted () {
    this.viewState = 'card';
  },
  methods: {
    checkSurveyStatus (item, index) {
      if (item.answered === false) {
        if (index > this.answeredCount) {
          return LockedSurvey;
        } else {
          return UnansweredSurvey;
        }
      } else {
        return AnsweredSurvey;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/IndividualTab.vue